import React, { useCallback, useRef, useState, useReducer, useEffect } from 'react';
import KeepAlive from 'react-activation';
import { message } from 'antd';
import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import dayjs from "dayjs";
import { get } from 'lodash-es';
import {getAuth, getUser} from "shj-utils";

import { filterSerchData} from '@/utils/common';
import { modalRemindWorkerOrderrFn } from '../formModels/remindWorkerOrder';
import { modalWorkerOrderBackFn } from '../formModels/workerOrderBack';
import { modalAddWorkOrderFn } from '../formModels/addWorkOrder';
import { modaleditDisposePersonFn } from '../formModels/editDisposePerson';
import CheckThePhone from "@/components/CheckThePhone";
import {AnewOpenWorkerOrder, WorkerOrderAccept} from "../components/popconfirmBtn";
import config from './config.json';
import {useNavigate} from "react-router-dom";
import {getTicketsListPage} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";
import UrlConfig from "@/api/UrlConfigs.ts";
import {authDict} from "shj-utils/dist/esm/utils";
export function PendingList() {
  const navigate = useNavigate()
  const listRef = useRef<any>();
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedCode, setSelectedCode] = useState([]);

  const fetchList = ({current, pageSize, query}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const newObj = { ...filterSerchData({ ...query }, ['lastDisposeDate', 'lastCallBackDate']) };
        const newObj_ = { ...filterSerchData({ ...newObj }, ['createdTime'], ['StartWith', 'EndWith']) };
        if (newObj_['companyIds']) {
          newObj_['companyIds'] = newObj_['companyIds'].toString();
        }
        getTicketsListPage({params: {pageId: current, pageSize} ,data: {...newObj_}}).then(res => {
          resolve(apiData2Table(res))
        })
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 获取筛选项
  const getSelection = () => {
    return new Promise((resolve, reject) => {
      Promise.all([
          httpOrgList(),
          getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.WorkerOrderStatusEnum'),
          getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.ConditionScreeningEnum'),
      ]).then(
        (resp) => {
          const listObj = {
            companyList: [...resp[0]],
            workerOrderStatusEnum: resp[1],
            conditionScreeningEnum: resp[2],
          };
          resolve(listObj);
        },
      );
    });
  };
  const onExport = useCallback((record: any) => {
    const searchData_ = listRef.current.getSearch().getFieldsValue();
    const newObj = { ...filterSerchData({ ...searchData_ }, ['createDate', 'lastDisposeDate', 'lastCallBackDate']) };
    if (newObj['companyIds']) {
      newObj['companyIds'] = newObj['companyIds'].toString();
    }

    let params = '';
    Object.keys(newObj).map((val) => {
      if (newObj[val]) params += val + '=' + newObj[val] + '&';
    });
    if (params) {
      params = '?' + params.slice(0, params.length - 1);
    }

    message.loading({ content: '导出中' });
    setExportLoading(true);
    // api
    //   .get(APIS.exportWorkerOrder + params, {
    //     responseType: 'arraybuffer',
    //   })
    //   .then((res: any) => {
    //     setExportLoading(false);
    //     if (res.status && res.status === 200) {
    //       exportFile({ response: res, data: res.data });
    //       message.success('下载完成');
    //       // message.destroy();
    //     } else {
    //       message.error('下载失败');
    //       // message.destroy();
    //     }
    //   })
    //   .catch(() => {
    //     setExportLoading(false);
    //     // message.destroy();
    //   });
  }, []);

  // 刷新
  const reload = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  // 退回
  const workerOrderBack = (id: any) => {
    modalWorkerOrderBackFn({
      fn: () => {
        const {
          current: { reload },
        } = listRef;
        reload();
      },
      id: id,
    });
  };
  // 批量催办
  const remindWorkerOrder = ({selectedRowKeys}) => {
    modalRemindWorkerOrderrFn({
      fn: () => {
        const {
          current: { reload },
        } = listRef;
        reload();
      },
      ids: selectedRowKeys, //工单id
    });
  };
  // 批量修改处理人
  const editDisposePerson = ({selectedRowKeys}) => {
    modaleditDisposePersonFn({
      ids: selectedRowKeys || [],
      fn: () => {
        const {
          current: { reload },
        } = listRef;
        reload();
      },
    });
  };
  const filterOption = (input: string, option: any) => option.children.indexOf(input) >= 0;
  const [exportLoading, setExportLoading] = useState(false);
  const extension = {
    request: { fetchList, getSelection },
    events: { onExport, remindWorkerOrder, filterOption, editDisposePerson },
    auth: authDict,
    status: {
      exportLoading: exportLoading,
    },
    customRender: {
      actionTool(text: any, record: any) {
          // isCreatePerson  创建人
          // isCopyPerson 抄送人
          // isChargePerson  责任人
          // isDisposePerson  处理人
          // 未受理:1
          // 已受理:2
          // 处理中:4
          // 已处理:5
          // 已退回:3
          // 回访中:7
          // 草稿:0
          // 已归档:6

          // 未受理:1
          // isCreatePerson  创建人    催办、罚单
          // isDisposePerson  处理人   受理、退回
          // isChargePerson  责任人   受理、退回
          // isCopyPerson 抄送人   受理、退回

          // 已退回:3
          // isCreatePerson  创建人    编辑、罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 已归档:6
          // isCreatePerson  创建人    罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 处理中:4
          // isCreatePerson  创建人    催办、罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 已处理:5
          // isCreatePerson  创建人    重新打开、罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 回访中:7
          // isCreatePerson  创建人    编辑、罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 已受理:2
          // isCreatePerson  创建人    催办、罚单
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

          // 草稿:0
          // isCreatePerson  创建人    编辑
          // isDisposePerson  处理人
          // isChargePerson  责任人
          // isCopyPerson 抄送人

        return <STableActions>
            <SActionBtn
              onClick={() => {
                navigate(
                  '/issues/pendingList/detail/' + record.id + '/' + record.issueId + '/' + record.companyCode,
                );
              }}
            >
              详情
            </SActionBtn>
            {(record.status == 3 || record.status == 0 || record.status == 7) && (
              <SActionBtn
                  auth="pendingListEdit"
                onClick={() => {
                  modalAddWorkOrderFn({
                    fn: () => {
                      const {
                        current: { reload },
                      } = listRef;
                      reload();
                    },
                    companyCode: record.companyCode,
                    isEdited: true,
                    issueId: record.issueId, //问题id
                    id: record.id, //工单id
                  });
                }}
              >
                编辑
              </SActionBtn>
            )}
            {record.status == 5 && (
              // 重新打开
              <AnewOpenWorkerOrder auth="pendingListReopen" id={record.id} fn={reload}></AnewOpenWorkerOrder>
            )}
            {record.status == 1 && (record.isDisposePerson || record.isChargePerson || record.isCopyPerson) && (
              [
                <WorkerOrderAccept auth="pendingListAccept" id={record.id} fn={reload}></WorkerOrderAccept>,
                <SActionBtn
                  auth="pendingListReturn"
                  onClick={() => {
                    workerOrderBack(record.id);
                  }}
                >
                  退回
                </SActionBtn>
              ]
            )}
            {(record.status == 1 || record.status == 2 || record.status == 4) && (
              <SActionBtn
                  auth="remindWorkerOrder"
                onClick={() => {
                  modalRemindWorkerOrderrFn({
                    fn: () => {
                      const {
                        current: { reload },
                      } = listRef;
                      reload();
                    },
                    ids: [record.id], //工单id
                  });
                }}
              >
                催办
              </SActionBtn>
            )}
          </STableActions>
      },
      checkPhone(text: any, record: any) {
        return (
          <CheckThePhone
            initValue={text}
            url={UrlConfig.PlusCrmWeb.TicketsIssueViewPhone}
            dataIndex={'feedbackPhone'}
            listRef={listRef}
            type={'GET'}
            data={{encodeValue: record.feedbackPhoneEncode}}
          />
        );
      },
    },
  };
  return (
    <SLowcodeList
        searchMode={'group'}
      config={{
        ...config,
      }}
      ref={listRef}
      {...extension}
    />
  );
}

export const PagePendingList = (props: any) => {
  return (
    <KeepAlive name={props.location.pathname} saveScrollPosition="screen" id={'keep' + location.pathname}>
      <PendingList {...props} />
    </KeepAlive>
  );
};

export default PagePendingList;
